import React from "react";
import Form from "react-bootstrap/Form";

const Filter = () => {
  const dummyFilter = [
    {
      title: "Region",
      data: [
        "Ukraine",
        "Poland",
        "Germany",
        "All EU countries",
        "Other countries",
      ],
    },
    {
      title: "Job title",
      data: [
        "Development",
        "JavaScript / Front-End",
        "Java",
        "C# / .NET",
        "Python",
        "PHP",
        "Node.js",
        "iOS",
      ],
    },
    {
      title: "Experience",
      data: ["2+ Years", "3+ Years", "4+ Years", "5+ Years"],
    },
  ];
  return (
    <Form>
      <div className="filter-wrapper">
        {dummyFilter.map((elem, i) => (
          <div className="filter-box" key={i}>
            <h6>{elem?.title}</h6>
            <div className="filter-listing">
              {elem?.data.map((e) => (
                <Form.Check
                  className="dev-filter"
                  type="checkbox"
                  id={`checkbox-${e}`}
                  label={e}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </Form>
  );
};

export default Filter;
